module.exports = __webpack_public_path__ + "static/media/homefurnitureandappliances.bd828bbe.svg";